function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.485 27.005L12.47 10h-.716l-.146.371c-.386.981-.552 1.984-.477 2.9.084 1.046.481 1.95 1.148 2.617l7.157 7.153.944-.943 6.617 7.394c.658.658 1.791.697 2.488 0a1.76 1.76 0 0 0 0-2.487zM16.12 21.384l-5.606 5.602a1.76 1.76 0 0 0 0 2.487c.652.652 1.78.71 2.489 0l5.605-5.602-2.488-2.487zM29.156 13.33l-3.18 3.178-.83-.83 3.18-3.177-.829-.829-3.18 3.178-.83-.83 3.18-3.177-.829-.829-4.147 4.145a2.925 2.925 0 0 0-.854 1.896c-.01.181-.051.36-.12.53l2.695 2.692c.17-.069.348-.11.53-.12a2.927 2.927 0 0 0 1.896-.853l4.147-4.145-.829-.829z",
  fill: "currentColor"
});

var SvgAudienceNutrition = function SvgAudienceNutrition(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceNutrition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_nutrition.11db6636.svg";
export { ForwardRef as ReactComponent };